/*
 * Import jQuery and make it global
 */
import $ from 'jquery';
window.$ = window.jQuery = $;

/*
 * Third-party libraries
 */
import 'bootstrap';

/*
 * Application modules
 */
import handleMenu from './modules/handle-menu';
import handleSlider from './modules/handle-slider';
import handleNavSecondary from './modules/handle-nav-secondary';
import handlePopups from './modules/handle-popups';
import handleMap from './modules/handle-map';
import handleMembers from './modules/handle-members';
import handleLogoReveal from './modules/handle-logo-reveal';
import handleTooltips from './modules/handle-tooltips';

/**
 * Main initialization function
 */
const initPage = () => {
    console.log('DOM ready - initializing modules');
    handleMenu();
    handleSlider();
    handleNavSecondary();
    handlePopups();
    handleMembers();
    handleLogoReveal();

    // Only initialize map if map element exists
    const mapElement = document.getElementById('map');
    if (mapElement) {
        handleMap(mapElement);
    }

    // Only initialize tooltips if team member actions exist
    if (document.querySelector('.member__actions')) {
        handleTooltips();
    }
};

/**
 * Initialize when DOM is ready
 */
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPage);
} else {
    initPage();
}
